import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const MaterialList = Loadable(lazy(() => import('./MaterialList')));
const AddMaterial = Loadable(lazy(() => import('./AddMaterial')));

const MaterialRoutes = [
  {
    path: '/Material/list',
    element: <MaterialList />,
    auth: authRoles.admin,
  },
  {
    path: '/Material/manage',
    element: <AddMaterial />,
    auth: authRoles.admin,
  },
];

export default MaterialRoutes;
